// This file is auto-generated by @hey-api/openapi-ts

export type CreatePromotionRequest = {
    startDate: string;
    endDate: string;
    image: (Blob | File);
    title?: string;
    url?: string;
    /**
     * Undefined or empty means 'all'
     */
    pointOfSaleIds?: Array<(string)>;
};

export type PromotionResponse = {
    id: string;
    organizationId: string;
    pointOfSaleIds: Array<(string)>;
    imageUrl: string;
    title?: string;
    url?: string;
    startDate: string;
    endDate: string;
    isCanceled: boolean;
    authorId: string;
};

export type UpdatePromotionRequest = {
    startDate: string;
    endDate: string;
    image?: (Blob | File);
    title?: string;
    url?: string;
    /**
     * Undefined or empty means 'all'
     */
    pointOfSaleIds?: Array<(string)>;
};

export type DateRangeResponse = {
    startDate: string;
    endDate: string;
};

export enum TimePeriod {
    THREE_MONTHS = 'three-months',
    SIX_MONTHS = 'six-months',
    TWELVE_MONTHS = 'twelve-months'
}

export type CountByMonth = {
    year: number;
    month: number;
    count: number;
};

export type GetPromotionsReportResponse = {
    timePeriod: TimePeriod;
    pointOfSaleIds: Array<(string)>;
    clickCountsByMonth: Array<CountByMonth>;
    viewCountsByMonth: Array<CountByMonth>;
    totalClickCount: number;
    totalViewCount: number;
};

export type GetPromotionStatsResponse = {
    viewCount: number;
    clickCount: number;
};

export enum ScheduleStatus {
    SCHEDULED = 'scheduled',
    ACTIVE = 'active',
    ENDED = 'ended'
}

export type ScratchingGameResponse = {
    id: string;
    organizationId: string;
    pointOfSaleIds: Array<(string)>;
    startDate: string;
    endDate: string;
    isCanceled: boolean;
    authorId: string;
};

export enum ScratchingGameRewardType {
    VOUCHER = 'voucher',
    DISCOUNT = 'discount',
    FREE_PRODUCT = 'freeProduct'
}

export type CreateScratchingGameRewardRequest = {
    type: ScratchingGameRewardType;
    title: string;
    quantity: number;
    winChance: number;
};

export enum ScratchingGameRequiredUserInteractionType {
    POS_REVIEW = 'POS_REVIEW',
    INSTAGRAM_LINK_CLICK = 'INSTAGRAM_LINK_CLICK',
    FACEBOOK_LINK_CLICK = 'FACEBOOK_LINK_CLICK',
    WEBSITE_LINK_CLICK = 'WEBSITE_LINK_CLICK',
    EMBASEMENT = 'EMBASEMENT'
}

export type CreateScratchingGameRequiredUserInteractionRequest = {
    type: ScratchingGameRequiredUserInteractionType;
    position: number;
};

export type CreateScratchingGameRequest = {
    startDate: string;
    endDate: string;
    /**
     * Undefined or empty means 'all'
     */
    pointOfSaleIds?: Array<(string)>;
    securityCode: string;
    rewards: Array<CreateScratchingGameRewardRequest>;
    requiredUserInteractions: Array<CreateScratchingGameRequiredUserInteractionRequest>;
};

export type ScratchingGameRewardResponse = {
    id: string;
    type: ScratchingGameRewardType;
    title: string;
    quantity: number;
    winChance: number;
    winCount: number;
};

export type ScratchingGameRequiredUserInteractionResponse = {
    id: string;
    type: ScratchingGameRequiredUserInteractionType;
    position: number;
};

export type ScratchingGameDetailsResponse = {
    id: string;
    organizationId: string;
    pointOfSaleIds: Array<(string)>;
    startDate: string;
    endDate: string;
    isCanceled: boolean;
    authorId: string;
    securityCode: string;
    rewards: Array<ScratchingGameRewardResponse>;
    requiredUserInteractions: Array<ScratchingGameRequiredUserInteractionResponse>;
};

export type UpdateScratchingGameRewardRequest = {
    type: ScratchingGameRewardType;
    title: string;
    quantity: number;
    winChance: number;
    id: string;
};

export type UpdateScratchingGameRewardsRequest = {
    create?: Array<CreateScratchingGameRewardRequest>;
    update?: Array<UpdateScratchingGameRewardRequest>;
    delete?: Array<(string)>;
};

export type UpdateScratchingGameRequest = {
    startDate: string;
    endDate: string;
    /**
     * Undefined or empty means 'all'
     */
    pointOfSaleIds?: Array<(string)>;
    securityCode: string;
    rewards?: UpdateScratchingGameRewardsRequest;
    requiredUserInteractions: Array<CreateScratchingGameRequiredUserInteractionRequest>;
};

/**
 * Selected period for the statistics
 */
export enum ScratchingGameTrendPeriod {
    LAST_7_DAYS = 'last-7-days',
    LAST_28_DAYS = 'last-28-days',
    ALL_TIME = 'all-time'
}

export type ScratchingGameDailyTrendDto = {
    /**
     * The number of views
     */
    views: number;
    /**
     * The number of participants
     */
    participants: number;
    /**
     * The number of winners
     */
    winners: number;
    /**
     * The date in YYYY-MM-DD format
     */
    date: string;
};

export type ScratchingGameWeeklyTrendDto = {
    /**
     * The number of views
     */
    views: number;
    /**
     * The number of participants
     */
    participants: number;
    /**
     * The number of winners
     */
    winners: number;
    /**
     * The startng date of the week in YYYY-MM-DD format
     */
    weekStarting: string;
};

export type ScratchingGameMonthlyTrendDto = {
    /**
     * The number of views
     */
    views: number;
    /**
     * The number of participants
     */
    participants: number;
    /**
     * The number of winners
     */
    winners: number;
    /**
     * The month in YYYY-MM format
     */
    month: string;
};

export type ScratchingGameStatVariationsDto = {
    /**
     * Variation of the number of views compared to the previous period
     */
    views: number;
    /**
     * Variation of the number of participants compared to the previous period
     */
    participants: number;
    /**
     * Variation of the number of winners compared to the previous period
     */
    winners: number;
};

/**
 * Granularity of the trend data
 */
export enum ScratchingGameTrendGranularity {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly'
}

export type GetScratchingGameStatsResponse = {
    /**
     * The number of views
     */
    views: number;
    /**
     * The number of participants
     */
    participants: number;
    /**
     * The number of winners
     */
    winners: number;
    period: ScratchingGameTrendPeriod;
    /**
     * The variations compared to the previous period
     */
    variations?: (ScratchingGameStatVariationsDto);
    trendGranularity: ScratchingGameTrendGranularity;
    /**
     * Trend data, varying by granularity: daily, weekly, or monthly. The actual structure depends on the trendGranularity value.
     */
    trendData: Array<(ScratchingGameDailyTrendDto | ScratchingGameWeeklyTrendDto | ScratchingGameMonthlyTrendDto)>;
};

export enum RedirectionLinkType {
    INSTAGRAM = 'instagram',
    FACEBOOK = 'facebook',
    WEB = 'web',
    LOYALTY = 'loyalty',
    NEWSLETTER = 'newsletter',
    OTHER = 'other'
}

export type RedirectionLinkResponse = {
    id: string;
    organizationId: string;
    pointOfSaleIds: Array<(string)>;
    url: string;
    type: RedirectionLinkType;
    label?: string;
};

export type CreateRedirectionLinkRequest = {
    type: RedirectionLinkType;
    /**
     * Undefined or empty means 'all'
     */
    pointOfSaleIds?: Array<(string)>;
    url: string;
    label?: string;
};

export type UpdateRedirectionLinkRequest = {
    type: RedirectionLinkType;
    /**
     * Undefined or empty means 'all'
     */
    pointOfSaleIds?: Array<(string)>;
    url: string;
    label?: string;
};

export type RedirectionLinkTypeStats = {
    type: RedirectionLinkType;
    clickCountsByMonth: Array<CountByMonth>;
    totalClickCount: number;
};

export type GetRedirectionLinksReportResponse = {
    timePeriod: TimePeriod;
    pointOfSaleIds: Array<(string)>;
    totalClickCount: number;
    statsPerType: Array<RedirectionLinkTypeStats>;
};

export enum CustomerLastVisitPeriod {
    LESS_THAN_A_MONTH = 'LESS_THAN_A_MONTH',
    BETWEEN_ONE_AND_THREE_MONTHS = 'BETWEEN_ONE_AND_THREE_MONTHS',
    MORE_THAN_THREE_MONTHS = 'MORE_THAN_THREE_MONTHS'
}

export type CustomerDataResponsePointOfSale = {
    id: string;
    name: string;
    visitedAt: string;
};

export type CustomerDataResponse = {
    id: string;
    firstName?: string;
    email?: string;
    phone?: string;
    optIn: boolean;
    pointOfSale: CustomerDataResponsePointOfSale;
};

export type GetCustomerReviewsReportResponse = {
    timePeriod: TimePeriod;
    pointOfSaleIds: Array<(string)>;
    countsByMonth: Array<CountByMonth>;
    totalCount: number;
    averageRating: (number) | null;
};

export type PointOfSaleManagerResponse = {
    firstName?: string;
    lastName?: string;
};

export type PointOfSaleContactResponse = {
    email: string;
    phone: string;
};

export type AddressDto = {
    street: string;
    zipCode: string;
    city: string;
    country: string;
};

export type PointOfSaleResponse = {
    id: string;
    name: string;
    siret?: string;
    logoUrl?: string;
    googleReviewUrl?: string;
    manager?: PointOfSaleManagerResponse;
    contact: PointOfSaleContactResponse;
    address: AddressDto;
};

export type SetGoogleReviewUrlRequest = {
    pointOfSaleId: string;
    googleReviewUrl: (string) | null;
};

export type SetGoogleReviewUrlsRequest = {
    googleReviewUrls: Array<SetGoogleReviewUrlRequest>;
};

export enum Plan {
    FREE = 'free',
    STANDARD = 'standard',
    PRO = 'pro',
    EXPERT = 'expert'
}

export enum Feature {
    PROMOTIONS = 'Promotions',
    SCRATCHING_GAMES = 'ScratchingGames',
    REDIRECTION_LINKS = 'RedirectionLinks',
    CUSTOMER_REVIEWS = 'CustomerReviews',
    CUSTOMER_DATA = 'CustomerData',
    QR_CODE_DOWNLOAD = 'QrCodeDownload'
}

export type OrganizationContactResponse = {
    email: string;
    phone: string;
};

export type OrganizationReceiptSettingsResponse = {
    expirationDelay: number;
    hideLogo: boolean;
};

export type OrganizationDetailsResponse = {
    id: string;
    isActivated: boolean;
    plan: Plan;
    enabledFeatures: Array<Feature>;
    name: string;
    siren: string;
    tvaId?: string;
    logoUrl?: string;
    contact: OrganizationContactResponse;
    address: AddressDto;
    billingAddress?: AddressDto;
    receiptSettings: OrganizationReceiptSettingsResponse;
};

export type GetReceiptsReportResponse = {
    timePeriod?: TimePeriod;
    pointOfSaleIds: Array<(string)>;
    totalCount: number;
};

export enum MemberRole {
    ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
    REGIONAL_MANAGER = 'REGIONAL_MANAGER',
    POINT_OF_SALE_MANAGER = 'POINT_OF_SALE_MANAGER'
}

export type MemberResponse = {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    role: MemberRole;
    pointOfSaleIds: Array<(string)>;
};

export type CreateSmsMarketingCampaignRequest = {
    title: string;
    pointOfSaleIds: Array<(string)>;
    message: string;
    /**
     * Specifies if the campaign should only be sent to users who have opted to be notified.
     */
    isOptInRequired?: boolean;
    sendAt?: string;
    lastVisitPeriods?: Array<CustomerLastVisitPeriod>;
};

export enum SmsMarketingCampaignStatus {
    SCHEDULED = 'SCHEDULED',
    COMPLETED = 'COMPLETED',
    CANCELED = 'CANCELED',
    FAILED = 'FAILED'
}

export type SmsMarketingCampaignResponse = {
    id: string;
    pointOfSaleIds: Array<(string)>;
    title: string;
    status: SmsMarketingCampaignStatus;
    scheduledAt: string;
    canceledAt?: string;
    message: string;
    isOptInRequired: boolean;
    lastVisitPeriods: Array<CustomerLastVisitPeriod>;
    totalSmsSent: number;
    totalSmsDelivered: number;
    totalSmsFailed: number;
    totalLinkClicks: number;
};

export type UpdateSmsMarketingCampaignRequest = {
    title: string;
    pointOfSaleIds: Array<(string)>;
    message: string;
    /**
     * Specifies if the campaign should only be sent to users who have opted to be notified.
     */
    isOptInRequired?: boolean;
    sendAt?: string;
    lastVisitPeriods?: Array<CustomerLastVisitPeriod>;
};

export type ScanReceiptQrCodeResponse = {
    /**
     * The id of the point of sale
     */
    pointOfSaleId: string;
    /**
     * The access token of the user
     */
    userToken: string;
};

export type ScanTillQrCodeResponse = {
    /**
     * The id of the last receipt from the till
     */
    receiptId?: string;
    /**
     * The id of the generated customer game
     */
    customerGameId?: string;
    /**
     * The id of the point of sale
     */
    pointOfSaleId: string;
    /**
     * The access token of the user
     */
    userToken: string;
};

export type ScanGameQrCodeRequest = {
    tillId: string;
};

export type ScanGameQrCodeResponse = {
    /**
     * The access token of the user
     */
    userToken: string;
};

export type ClaimReceiptRequest = {
    /**
     * The code to claim the receipt
     */
    securityCode: string;
};

export enum ReceiptDocumentFormat {
    PDF = 'pdf',
    HTML = 'html'
}

export type JsonReceiptDocumentResponse = {
    format: ReceiptDocumentFormat;
};

export type HtmlReceiptDocumentResponse = {
    format: ReceiptDocumentFormat;
    /**
     * The URL of the document
     */
    url: string;
};

export type PdfReceiptDocumentResponse = {
    format: ReceiptDocumentFormat;
    /**
     * The URL of the document
     */
    url: string;
};

export enum GameType {
    SCRATCH_GAME = 'scratch-game',
    CUSTOMER_GAME = 'customer-game'
}

export enum ScratchGameResult {
    WON = 'Won',
    LOST = 'Lost'
}

export type ScratchGamePrizeResponse = {
    id: string;
    title: string;
};

export enum ScratchGameActionType {
    POS_REVIEW = 'POS_REVIEW',
    INSTAGRAM_LINK_CLICK = 'INSTAGRAM_LINK_CLICK',
    FACEBOOK_LINK_CLICK = 'FACEBOOK_LINK_CLICK',
    WEBSITE_LINK_CLICK = 'WEBSITE_LINK_CLICK',
    EMBASEMENT = 'EMBASEMENT'
}

export type ScratchGameResponse = {
    id: string;
    gameType: GameType;
    receiptId: string;
    result: ScratchGameResult;
    prize?: ScratchGamePrizeResponse;
    requiredAction?: ScratchGameActionType;
    playedAt?: string;
    prizeCollectedAt?: string;
};

/**
 * The result of the game
 */
export enum CustomerGameResult {
    WON = 'WON',
    LOST = 'LOST'
}

export type CustomerGameResponse = {
    /**
     * The id of the game
     */
    id: string;
    gameType: GameType;
    result: CustomerGameResult;
    /**
     * The date and time the game was played
     */
    playedAt?: string;
};

export type PointOfSaleAddressResponse = {
    street: string;
    zipCode: string;
    city: string;
    country: string;
};

export type PointOfSaleRedirectionLinkResponse = {
    /**
     * The id of the redirection link
     */
    id: string;
    type: RedirectionLinkType;
    /**
     * The url of the redirection link
     */
    url: string;
    /**
     * The label of the redirection link
     */
    label?: string;
};

export type PointOfSalePromotionResponse = {
    /**
     * The id of the promotion
     */
    id: string;
    /**
     * The image url of the promotion
     */
    imageUrl: string;
    /**
     * The title of the promotion
     */
    title?: string;
    /**
     * The url of the promotion
     */
    url?: string;
};

export type PointOfSaleProfileResponse = {
    /**
     * The id of the point of sale
     */
    id: string;
    /**
     * The name of the point of sale
     */
    name: string;
    /**
     * The logo url of the point of sale
     */
    logoUrl?: string;
    /**
     * Wether the logo should be hidden on the receipt
     */
    hideLogoOnReceipt: boolean;
    /**
     * The address of the point of sale
     */
    address: (PointOfSaleAddressResponse);
    /**
     * The google review url of the point of sale
     */
    googleReviewUrl?: string;
    /**
     * The redirection links of the point of sale
     */
    redirectionLinks: Array<PointOfSaleRedirectionLinkResponse>;
    /**
     * The promotion of the point of sale
     */
    promotion?: (PointOfSalePromotionResponse);
};

export type ReceiptResponse = {
    /**
     * The id of the receipt
     */
    id: string;
    /**
     * The date and time the receipt was created
     */
    createdAt: string;
    /**
     * The documents of the receipt
     */
    documents: Array<(JsonReceiptDocumentResponse | HtmlReceiptDocumentResponse | PdfReceiptDocumentResponse)>;
    /**
     * The point of sale profile of the receipt
     */
    pointOfSale: (PointOfSaleProfileResponse);
    /**
     * The game associated with the receipt
     */
    game?: (ScratchGameResponse | CustomerGameResponse);
};

export type RetrieveReceiptBySmsRequest = {
    /**
     * The claim token received by SMS to retrieve the receipt
     */
    claimToken: string;
};

export type SubmitPosReviewRequest = {
    rating: number;
    pointOfSaleId: string;
    receiptId?: string;
};

export type SubmitEmbasementRequest = {
    receiptId?: string;
    firstName?: string;
    email?: string;
    phone?: string;
    optIn?: boolean;
};

export type RecordRedirectionLinkClickRequest = {
    receiptId?: string;
    pointOfSaleId: string;
    redirectionLinkId: string;
};

export type RecordPromotionClickRequest = {
    receiptId?: string;
    pointOfSaleId: string;
    promotionId: string;
};

export type CollectScratchGamePrizeRequest = {
    securityCode: string;
};

export type RegisterUserRequest = {
    email: string;
    phone?: string;
    firstName?: string;
    lastName?: string;
    password: string;
    embasementOptIn?: boolean;
};

export enum OrganizationMemberRole {
    ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
    REGIONAL_MANAGER = 'REGIONAL_MANAGER',
    POINT_OF_SALE_MANAGER = 'POINT_OF_SALE_MANAGER'
}

export type OrganizationMember = {
    id: string;
    userId: string;
    role: OrganizationMemberRole;
    organizationId: string;
    pointOfSaleIds: Array<(string)>;
};

export type User = {
    id: string;
    email?: string;
    emailVerified: boolean;
    phone?: string;
    phoneVerified: boolean;
    firstName?: string;
    lastName?: string;
    organizationMembership?: OrganizationMember;
    embasementOptIn?: boolean;
};

export type RegisterUserResponse = {
    user: User;
    token: string;
};

export type LoginRequest = {
    email: string;
    password: string;
};

export type LoginResponse = {
    user: User;
    token: string;
};

export type UpgradeFromJwtV1Response = {
    token: string;
};

export type UpgradeToApiKeyRequest = {
    tillId: string;
};

export type TillInfoPointOfSale = {
    id: string;
    name: string;
};

export type TillInfoOrganization = {
    id: string;
    name: string;
};

export type TillInfo = {
    id: string;
    name: string;
    pointOfSale: TillInfoPointOfSale;
    organization: TillInfoOrganization;
};

export type UpgradeToApiKeyResponse = {
    till: TillInfo;
    key: string;
};

export type CheckEmailAvailabilityRequest = {
    email: string;
};

export type CheckEmailAvailabilityResponse = {
    isAvailable: boolean;
    isGoogleAccount?: boolean;
};

export type UpdateUserRequest = {
    phone?: string;
    firstName?: string;
    lastName?: string;
    embasementOptIn?: boolean;
};

export type Address = {
    street: string;
    zipCode: string;
    city: string;
    country: string;
};

export type PointOfSaleInfo = {
    id: string;
    name: string;
    logoUrl?: string;
    siret?: string;
    address: Address;
};

export type UserReceipt = {
    id: string;
    createdAt: string;
    pointOfSale: PointOfSaleInfo;
};

export type ChangePasswordRequest = {
    newPassword: string;
};

export type ResetPasswordRequest = {
    token: string;
    newPassword: string;
};

export type CreateOrganizationApiKeyRequest = {
    name: string;
};

export type CreateOrganizationApiKeyResponse = {
    /**
     * Use this in requests headers "x-api-key"
     */
    key: string;
};

export enum OfferPlan {
    FREE = 'free',
    STANDARD = 'standard',
    PRO = 'pro',
    EXPERT = 'expert'
}

export type CreateOrganizationRequest = {
    name: string;
    siren: string;
    tvaId?: string;
    contactEmail: string;
    contactPhone: string;
    offerPlan?: OfferPlan;
    multiplePointsOfSale: boolean;
    street: string;
    zipCode: string;
    city: string;
    country: string;
    logo?: (Blob | File);
};

export type OrganizationSettings = {
    hideLogoOnReceipts: boolean;
    parseReceiptDocuments: boolean;
    receiptsExpiration: number;
};

export type Organization = {
    id: string;
    name: string;
    logoUrl?: string;
    siren: string;
    tvaId?: string;
    isActivated: boolean;
    contactEmail: string;
    contactPhone: string;
    address: Address;
    settings: OrganizationSettings;
    billingAddressId?: string;
};

export type Offer = {
    id: string;
    organizationId: string;
    plan: OfferPlan;
};

export type CreateOrganizationResponse = {
    organization: Organization;
    offer: Offer;
    subscriptionCheckoutUrl?: string;
};

export type AddPointOfSaleRequest = {
    name: string;
    siret?: string;
    contactEmail: string;
    contactPhone: string;
    managerLastName?: string;
    managerFirstName?: string;
    street: string;
    zipCode: string;
    city: string;
    country: string;
    logo?: (Blob | File);
};

export type PointOfSale = {
    id: string;
    name: string;
    logoUrl?: string;
    siret?: string;
    contactEmail: string;
    contactPhone: string;
    managerLastName?: string;
    managerFirstName?: string;
    organizationId: string;
    googleReviewUrl?: string;
    address: Address;
};

export type UpdateOrganizationRequest = {
    name: string;
    siren: string;
    tvaId?: string;
    contactEmail: string;
    contactPhone: string;
    street: string;
    zipCode: string;
    city: string;
    country: string;
    logo?: (Blob | File);
};

export type OrderQrCodesRequest = {
    tillIds?: Array<(string)>;
};

export enum QrCodeOrderStatus {
    PAID = 'paid',
    UNPAID = 'unpaid'
}

export type QrCodeOrder = {
    id: string;
    createdAt: string;
    status: QrCodeOrderStatus;
    checkoutId: string;
    checkoutUrl: string;
    organizationId: string;
    tillIds: Array<(string)>;
};

export type Till = {
    id: string;
    name: string;
    securityCode?: string;
    defaultSecurityCode: string;
    pointOfSaleId: string;
    softwareMetadata: ((SoftwareMetadata) | null);
    parentTillId?: string;
    createdAt: string;
    partnerDeviceId?: string;
};

export type TillsByPointOfSale = {
    id: string;
    name: string;
    tills: Array<Till>;
};

export type Invoice = {
    /**
     * Unique identifier for the invoice.
     */
    id: string;
    /**
     * A unique, identifying string that appears on emails sent to the customer for this invoice. This starts with the customer’s unique invoice_prefix if it is specified.
     */
    number: string;
    /**
     * Whether payment was successfully collected for this invoice.
     */
    paid: boolean;
    /**
     * Total after discounts and taxes.
     */
    total: number;
    /**
     * Datetime at which the invoice was created.
     */
    createdAt: string;
    /**
     * The link to download the PDF for the invoice
     */
    url: string;
};

/**
 * The type of the payment method.
 */
export enum PaymentMethodType {
    CARD = 'card',
    SEPA_DEBIT = 'sepa_debit'
}

export type CardPaymentMethod = {
    /**
     * Unique identifier for the payment method.
     */
    id: string;
    type: PaymentMethodType;
    /**
     * Whether payment method is the organization's default.
     */
    isDefault: boolean;
    /**
     * Card brand. Can be `amex`, `diners`, `discover`, `eftpos_au`, `jcb`, `mastercard`, `unionpay`, `visa`, or `unknown`.
     */
    brand: string;
    /**
     * Two-digit number representing the card's expiration month.
     */
    expirationMonth: number;
    /**
     * Four-digit number representing the card's expiration year.
     */
    expirationYear: number;
    /**
     * The last four digits of the card.
     */
    last4Digits: string;
};

export type SepaDebitPaymentMethod = {
    /**
     * Unique identifier for the payment method.
     */
    id: string;
    type: PaymentMethodType;
    /**
     * Whether payment method is the organization's default.
     */
    isDefault: boolean;
    /**
     * Bank code of bank associated with the bank account.
     */
    bankCode: string;
    /**
     * Branch code of bank associated with the bank account.
     */
    branchCode: string;
    /**
     * Two-letter ISO code representing the country the bank account is located in.
     */
    country: string;
    /**
     * Last four characters of the IBAN.
     */
    last4Characters: string;
};

export type GetOrganizationPaymentMethodsResponse = {
    /**
     * Contains an array of payment methods.
     */
    data: Array<(CardPaymentMethod | SepaDebitPaymentMethod)>;
};

export type ChangeOrganizationPaymentMethodResponse = {
    checkoutUrl: string;
};

export type ChangeOrganizationOfferRequest = {
    plan: OfferPlan;
};

export enum ChangeOrganizationOfferMode {
    CHECKOUT_SESSION = 'CHECKOUT_SESSION',
    MANUAL = 'MANUAL',
    AUTO = 'AUTO'
}

export type ChangeOrganizationOfferResponse = {
    mode: ChangeOrganizationOfferMode;
    /**
     * URL for the checkout session.
     */
    checkoutUrl?: string;
};

export type OrganizationMemberInvitationRequest = {
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    role: OrganizationMemberRole;
    pointOfSaleIds: Array<(string)>;
};

export type OrganizationMemberInvitation = {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    role: OrganizationMemberRole;
    pointOfSaleIds: Array<(string)>;
};

export type JoinOrganizationRequest = {
    token: string;
    email: string;
    password: string;
};

export type UpdateOrganizationMemberRequest = {
    role: OrganizationMemberRole;
    pointOfSaleIds: Array<(string)>;
};

export type SoftwareMetadata = {
    lastUsedAt: string;
    version: string;
};

export type AddTillRequest = {
    name?: string;
    partnerDeviceId?: string;
};

export type ApiKey = {
    value: string;
    revokedAt?: string;
    lastUsedAt?: string;
};

export type CreateTillResponse = {
    till: Till;
    apiKey: ApiKey;
};

export type UpdatePointOfSaleInfoRequest = {
    name: string;
    siret?: string;
    contactEmail: string;
    contactPhone: string;
    managerLastName?: string;
    managerFirstName?: string;
    street: string;
    zipCode: string;
    city: string;
    country: string;
    logo?: (Blob | File);
};

export type SetupPartnerIntegrationRequest = {
    partnerPointOfSaleId: string;
    partnerDeviceIds: Array<(string)>;
    credentials: {
        [key: string]: unknown;
    };
};

export type WebhookInfo = {
    url: string;
    authorizationToken?: string;
};

export type SetupPartnerIntegrationResponse = {
    webhookInfo?: WebhookInfo;
};

export enum Partner {
    CASHMAG = 'CASHMAG',
    TILLER = 'TILLER',
    ZELTY = 'ZELTY',
    HIBOUTIK = 'HIBOUTIK',
    EASYSHOP = 'EASYSHOP',
    ODOO = 'ODOO',
    CAISSE_ENREGISTREUSE = 'CAISSE_ENREGISTREUSE'
}

export type PartnerIntegration = {
    id: string;
    pointOfSaleId: string;
    partner: Partner;
    partnerPointOfSaleId: string;
    config: (CashmagConfig | TillerConfig | ZeltyConfig | HiboutikConfig | EasyShopConfig | OdooConfig | CaisseEnregistreuseConfig);
};

export type ReceiptDocument = {
    id: string;
    receiptId: string;
    format: ReceiptDocumentFormat;
    url: string;
    rawUrl?: string;
    position?: number;
    printedAt?: string;
};

export enum ReceiptItemType {
    PRODUCT = 'product',
    SUBTOTAL = 'subtotal'
}

/**
 * Code à 3 lettres permettant d'identifier l'unité de la quantité. La liste est disponible [ici](https://www.zoho.com/in/books/kb/gst/unit-code-list.html). Utilisez PCS si aucun autre code n'est applicable.
 */
export enum QuantityCode {
    BAG = 'BAG',
    BAL = 'BAL',
    BDL = 'BDL',
    BKL = 'BKL',
    BOX = 'BOX',
    BTL = 'BTL',
    CAN = 'CAN',
    CTN = 'CTN',
    CCM = 'CCM',
    CBM = 'CBM',
    CMS = 'CMS',
    DRM = 'DRM',
    DOZ = 'DOZ',
    GGK = 'GGK',
    GRS = 'GRS',
    KME = 'KME',
    KGS = 'KGS',
    KLR = 'KLR',
    MTS = 'MTS',
    MLT = 'MLT',
    MTR = 'MTR',
    NOS = 'NOS',
    PAC = 'PAC',
    PCS = 'PCS',
    PRS = 'PRS',
    LTR = 'LTR',
    CLTR = 'CLTR',
    GRM = 'GRM',
    QTL = 'QTL',
    ROL = 'ROL',
    SQY = 'SQY',
    SET = 'SET',
    SQF = 'SQF',
    SQM = 'SQM',
    TBS = 'TBS',
    TUB = 'TUB',
    TGM = 'TGM',
    THD = 'THD',
    TON = 'TON',
    UNT = 'UNT',
    UGS = 'UGS',
    YDS = 'YDS'
}

export type Vat = {
    /**
     * Pourcentage du montant attribué à la TVA, exprimé en nombre à virgule. 5.5 pour 5,5%, 20 pour 20%, etc...
     */
    rate?: number;
    /**
     * Montant de la TVA, en centimes.
     */
    amount?: number;
    code?: string;
    /**
     * Montant sans TVA, en centimes.
     */
    totalAmountExcVat: number;
    /**
     * Montant incluant la TVA, en centimes.
     */
    totalAmountIncVat: number;
};

export type Discount = {
    amount?: number;
    percentage?: number;
    description?: string;
};

export type Product = {
    type: ReceiptItemType;
    /**
     * La dénomination du produit.
     */
    name?: string;
    category?: string;
    productId?: string;
    /**
     * La quantité du produit.
     */
    quantity: number;
    quantityCode?: QuantityCode;
    isOffered?: boolean;
    /**
     * Montant total de la ligne, incluant la TVA, en centimes.
     */
    totalAmountIncVat: number;
    /**
     * Montant total de la ligne, sans TVA, en centimes.
     */
    totalAmountExcVat?: number;
    /**
     * Prix unitaire du produit incluant la TVA, en centimes.
     */
    unitPriceIncVat?: number;
    freeText?: string;
    vats?: Array<Vat>;
    discounts?: Array<Discount>;
};

export type SubTotal = {
    type: ReceiptItemType;
    name?: string;
    /**
     * Montant du sous-total en centimes.
     */
    amount: number;
};

export enum PaymentType {
    CARD = 'card',
    CASH = 'cash',
    CASH_RETURN = 'cashReturn',
    OTHER = 'other',
    VOUCHER = 'voucher',
    LOYALTY = 'loyalty'
}

export enum CardPaymentTransactionType {
    PURCHASE = 'purchase',
    RETURN = 'return'
}

export type CardPayment = {
    type: PaymentType;
    /**
     * Montant du paiement en centimes.
     */
    amount: number;
    cardType?: string;
    network?: string;
    maskedPan?: string;
    timestamp?: string;
    terminalId?: string;
    cardId?: string;
    referenceNumber?: string;
    authorizationCode?: string;
    authorizationMethodType?: string;
    transactionId?: string;
    transactionType?: CardPaymentTransactionType;
    transactionRawText?: string;
    headerText?: string;
    footerText?: string;
};

export type CashPayment = {
    type: PaymentType;
    /**
     * Montant du paiement en centimes.
     */
    amount: number;
    handedAmount?: number;
};

export type CashReturnPayment = {
    type: PaymentType;
    /**
     * Montant du paiement en centimes.
     */
    amount: number;
    handedAmount?: number;
};

export type OtherPayment = {
    type: PaymentType;
    /**
     * Montant du paiement en centimes.
     */
    amount: number;
    externalType?: string;
};

export type VoucherPayment = {
    type: PaymentType;
    /**
     * Montant du paiement en centimes.
     */
    amount: number;
    referenceNumber?: string;
};

export type LoyaltyPayment = {
    type: PaymentType;
    /**
     * Montant du paiement en centimes.
     */
    amount: number;
    cardType?: string;
    maskedPan?: string;
};

export type Cashier = {
    name: string;
    role?: string;
};

export type QrCode = {
    content: string;
    headerText?: string;
    footerText?: string;
};

export enum BarcodeFormat {
    EAN8 = 'ean8',
    EAN13 = 'ean13',
    CODE11 = 'code11',
    CODE39 = 'code39',
    CODE93 = 'code93',
    CODE128 = 'code128',
    INTERLEAVED2OF5 = 'interleaved2of5',
    ITF14 = 'itf14',
    UPC_A = 'upcA'
}

export type Barcode = {
    format: BarcodeFormat;
    content: string;
    headerText?: string;
    footerText?: string;
};

export type ReceiptContent = {
    /**
     * Texte libre affiché en haut du ticket de caisse
     */
    headerText?: string;
    /**
     * Texte libre affiché en bas du ticket de caisse
     */
    footerText?: string;
    /**
     * Texte libre affiché sur le ticket de caisse
     */
    freeText?: string;
    /**
     * Référence interne du ticket émis par le commerce. C'est un identifiant unique partagé entre le logiciel de caisse du commerçant et Noticia. Il sera affiché en haut du ticket dématérialisé.
     */
    receiptNumber: string;
    /**
     * Date d'émission du ticket (ou de création de la transaction) pour le commerçant. Elle doit être envoyée comme une chaine de caractère au format [ISO 8601](https://fr.wikipedia.org/wiki/ISO_8601). Elle sera affiché en haut du ticket dématérialisé.
     */
    receiptTimestamp: string;
    /**
     * Code [ISO 4217](https://fr.wikipedia.org/wiki/ISO_4217) de l'unité monétaire a utiliser pour l'affichage des montants sur le ticket. Par exemple EUR pour Euro.
     */
    currencyIsoCode: string;
    /**
     * Montant total de la TVA, en centimes.
     */
    totalVatAmount?: number;
    /**
     * Montant total des achats, sans TVA, en centimes.
     */
    totalPriceExcVat?: number;
    /**
     * Montant total des achats, incluant la TVA, en centimes.
     */
    totalPriceIncVat: number;
    /**
     * Informations facultatives sur le caissier
     */
    cashier?: (Cashier);
    /**
     * Le détail de la TVA pouvant inclure plusieurs lignes sur le détail des taxes appliquées au total.
     */
    vats?: Array<Vat>;
    /**
     * Liste des lignes affichées sur le détail du ticket de caisse, pouvant inclure des produits et des sous-totaux.
     */
    items: Array<(Product | SubTotal)>;
    /**
     * Liste des réductions appliquées sur l'ensemble du ticket.
     */
    discounts?: Array<Discount>;
    /**
     * Liste des règlements reçus par le commerçant pour ce ticket.
     */
    payments: Array<(CardPayment | CashPayment | OtherPayment | CashReturnPayment | VoucherPayment | LoyaltyPayment)>;
    /**
     * Contient les éléments nécessaires à la configuration de l'affichage d'un qr-code à la fin du ticket.
     */
    qrCode?: (QrCode);
    /**
     * Contient les éléments nécessaires à la configuration de l'affichage d'un code barre à la fin du ticket.
     */
    barcode?: (Barcode);
};

export type ReceiptDetails = {
    id: string;
    ownerId?: string;
    pointOfSaleId: string;
    createdAt: string;
    documents: Array<ReceiptDocument>;
    content?: ReceiptContent;
};

export type RedirectionLink = {
    id: string;
    type: RedirectionLinkType;
    label?: string;
    url: string;
    pointOfSaleIds: Array<(string)>;
    organizationId: string;
};

export enum PromotionContentType {
    TEXT = 'text',
    IMAGE = 'image'
}

export type PromotionTextContent = {
    type: PromotionContentType;
    text: string;
    backgroundColor: string;
};

export type PromotionImageContent = {
    type: PromotionContentType;
    imageUrl: string;
};

export type PromotionInfo = {
    id: string;
    content: (PromotionTextContent | PromotionImageContent);
    title?: string;
    url?: string;
};

export type PointOfSaleMedias = {
    googleReviewUrl?: string;
    redirectionLinks: Array<RedirectionLink>;
    promotion: ((PromotionInfo) | null);
};

export type PointOfSaleProfile = {
    id: string;
    name: string;
    logoUrl?: string;
    siret?: string;
    address: Address;
    medias: ((PointOfSaleMedias) | null);
    hideLogoOnReceipt: boolean;
};

export type ClaimReceiptResponse = {
    receipt?: ReceiptDetails;
    scratchGame?: ScratchGameResponse;
    pointOfSale: PointOfSaleProfile;
    error?: string;
    anonymousToken?: string;
};

export type AddReceiptRequest = {
    /**
     * Date de création du ticket (si antérieure) au format [ISO 8601](https://fr.wikipedia.org/wiki/ISO_8601)
     */
    createdAt?: string;
    /**
     * Code de sécurité à 4 chiffres qui pourra être demandé au client pour pouvoir récupérer son ticket
     */
    securityCode?: string;
    /**
     * Données du ticket de caisse
     */
    content?: (ReceiptContent);
};

export type TillDetails = {
    id: string;
    name: string;
    securityCode?: string;
    defaultSecurityCode: string;
    pointOfSaleId: string;
    parentTillId?: string;
    createdAt: string;
    apiKey?: string;
    partnerDeviceId?: string;
};

export type UpdateTillRequest = {
    name: string;
    defaultSecurityCode: string;
    parentTillId: (string) | null;
};

export type ReceiptPageData = {
    receipt: ReceiptDetails;
    scratchGame?: ScratchGameResponse;
    pointOfSale: PointOfSaleProfile;
};

export type AddReceiptDocumentRequest = {
    format: ReceiptDocumentFormat;
    position?: number;
};

export type SendReceiptRequest = {
    phoneNumber: string;
};

export type SaveReceiptDocumentPrintedAt = {
    printedAt: string;
};

export type FormData = {
    [key: string]: unknown;
};

export type ContactRequest = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    comment: string;
};

export type CashmagConfig = {
    apiKey: string;
};

export type TillerCredentials = {
    login: string;
    password: string;
    providerToken: string;
};

export type TillerConfig = {
    restaurantToken: string;
    providerToken: string;
};

export type ZeltyConfig = {
    apiKey: string;
};

export type HiboutikConfig = {
    account: string;
    username: string;
    apiKey: string;
};

export type EasyShopConfig = {
    apiKey: string;
};

export type OdooConfig = {
    url: string;
    db: string;
    username: string;
    apiKey: string;
};

export type CaisseEnregistreuseConfig = {
    shopId: string;
    apiKey: string;
};

export type PartnerDevice = {
    id: string;
    name: string;
    lastActivity?: string;
};

export type PartnerPointOfSale = {
    id: string;
    name: string;
    address?: AddressDto;
    devices: Array<PartnerDevice>;
};

/**
 * The key of the feature flag
 */
export enum FeatureFlagKey {
    ORGANIZATION_MEMBERS = 'organization_members',
    ORGANIZATION_MEMBERS_ROLES = 'organization_members_roles',
    SCAN_TILL_QR_CODE_LIMITER_BAN = 'scan_till_qr_code_limiter_ban',
    SMS_MARKETING_CAMPAIGN = 'sms_marketing_campaign'
}

export type FeatureFlag = {
    key: FeatureFlagKey;
    /**
     * Indicates whether the feature flag is enabled
     */
    isEnabled: boolean;
};

export type GetPointOfSalesResponse = (Array<PointOfSaleResponse>);

export type GetPointOfSales1Response = (Array<PointOfSaleResponse>);

export type AddPointOfSaleData = {
    formData: AddPointOfSaleRequest;
    organizationId: string;
};

export type AddPointOfSaleResponse = (PointOfSale);

export type SetGoogleReviewUrlsData = {
    requestBody: SetGoogleReviewUrlsRequest;
};

export type SetGoogleReviewUrlsResponse = (Array<PointOfSaleResponse>);

export type GetPointOfSaleProfileResponse = (PointOfSaleProfileResponse);

export type GetPointOfSaleTillsData = {
    pointOfSaleId: string;
};

export type GetPointOfSaleTillsResponse = (Array<Till>);

export type AddTillData = {
    pointOfSaleId: string;
    requestBody?: AddTillRequest;
};

export type AddTillResponse = (CreateTillResponse);

export type UpdatePointOfSaleData = {
    formData: UpdatePointOfSaleInfoRequest;
    pointOfSaleId: string;
};

export type UpdatePointOfSaleResponse = (PointOfSale);

export type GetPointOfSaleByIdData = {
    pointOfSaleId: string;
};

export type GetPointOfSaleByIdResponse = (PointOfSale);

export type SetupPartnerIntegrationData = {
    partner: string;
    pointOfSaleId: string;
    requestBody: SetupPartnerIntegrationRequest;
};

export type SetupPartnerIntegrationResponse2 = (SetupPartnerIntegrationResponse);

export type GetPartnerIntegrationData = {
    pointOfSaleId: string;
};

export type GetPartnerIntegrationResponse = (PartnerIntegration);

export type GetReceiptsReportData = {
    period?: TimePeriod;
    pointOfSaleIds?: Array<(string)>;
};

export type GetReceiptsReportResponse2 = (GetReceiptsReportResponse);

export type ClaimReceiptData = {
    requestBody: ClaimReceiptRequest;
};

export type ClaimReceiptResponse2 = (ReceiptResponse);

export type GetReceiptByIdResponse = (ReceiptResponse);

export type RetrieveReceiptBySmsData = {
    requestBody: RetrieveReceiptBySmsRequest;
};

export type RetrieveReceiptBySmsResponse = (ReceiptResponse);

export type GetUserReceiptsResponse = (Array<UserReceipt>);

export type ClaimTillDemoReceiptResponse = (ClaimReceiptResponse);

export type ClaimTillLastReceiptData = {
    code?: string;
    tillId: string;
};

export type ClaimTillLastReceiptResponse = (ClaimReceiptResponse);

export type AddTillReceiptData = {
    requestBody?: AddReceiptRequest;
    /**
     * Identifiant unique de la caisse
     */
    tillId: string;
    /**
     * Clé d'API de la caisse
     */
    xApiKey: string;
};

export type AddTillReceiptResponse = (ReceiptDetails);

export type ClaimDemoReceiptResponse = (ClaimReceiptResponse);

export type ClaimReceiptV1Data = {
    claimToken?: string;
    code?: string;
    receiptId: string;
};

export type ClaimReceiptV1Response = (ClaimReceiptResponse);

export type GetReceiptByIdV1Data = {
    receiptId: string;
};

export type GetReceiptByIdV1Response = (ReceiptPageData);

export type InspectReceiptData = {
    receiptId: string;
    securityHash: string;
};

export type InspectReceiptResponse = (ReceiptPageData);

export type UploadDocumentData = {
    formData: AddReceiptDocumentRequest;
    receiptId: string;
    xApiKey: string;
};

export type UploadDocumentResponse = (ReceiptDocument);

export type SendReceiptData = {
    receiptId: string;
    requestBody: SendReceiptRequest;
    xApiKey: string;
};

export type ScanReceiptQrCodeResponse2 = (ScanReceiptQrCodeResponse);

export type ScanTillQrCodeResponse2 = (ScanTillQrCodeResponse);

export type ScanGameQrCodeData = {
    requestBody: ScanGameQrCodeRequest;
};

export type ScanGameQrCodeResponse2 = (ScanGameQrCodeResponse);

export type SubmitPosReviewData = {
    requestBody: SubmitPosReviewRequest;
};

export type SubmitEmbasementData = {
    requestBody: SubmitEmbasementRequest;
};

export type RecordRedirectionLinkClickData = {
    requestBody: RecordRedirectionLinkClickRequest;
};

export type RecordPromotionClickData = {
    requestBody: RecordPromotionClickRequest;
};

export type PlayScratchGameData = {
    scratchGameId: string;
};

export type PlayScratchGameResponse = (ScratchGameResponse);

export type CollectScratchGamePrizeData = {
    requestBody: CollectScratchGamePrizeRequest;
    scratchGameId: string;
};

export type CollectScratchGamePrizeResponse = (ScratchGameResponse);

export type RegisterData = {
    requestBody: RegisterUserRequest;
};

export type RegisterResponse = (RegisterUserResponse);

export type LoginData = {
    requestBody: LoginRequest;
};

export type LoginResponse2 = (LoginResponse);

export type GoogleLoginData = {
    redirectUri: string;
};

export type UpgradeFromJwtV1Response2 = (UpgradeFromJwtV1Response);

export type UpgradeToApiKeyData = {
    requestBody: UpgradeToApiKeyRequest;
};

export type UpgradeToApiKeyResponse2 = (UpgradeToApiKeyResponse);

export type CheckEmailAvailabilityData = {
    requestBody: CheckEmailAvailabilityRequest;
};

export type CheckEmailAvailabilityResponse2 = (CheckEmailAvailabilityResponse);

export type ChangePasswordData = {
    requestBody: ChangePasswordRequest;
};

export type SendResetPasswordData = {
    email: string;
    redirectUri: string;
};

export type ResetPasswordData = {
    requestBody: ResetPasswordRequest;
};

export type GetAuthenticatedUserResponse = (User);

export type UpdateAuthenticatedUserData = {
    requestBody: UpdateUserRequest;
};

export type UpdateAuthenticatedUserResponse = (User);

export type GetOrganizationTillsData = {
    organizationId: string;
};

export type GetOrganizationTillsResponse = (Array<TillsByPointOfSale>);

export type UpdateSoftwareMetadataData = {
    requestBody: SoftwareMetadata;
    tillId: string;
    xApiKey: string;
};

export type UpdateSoftwareMetadataResponse = (Till);

export type GetTillByApiKeyData = {
    xApiKey: string;
};

export type GetTillByApiKeyResponse = (TillInfo);

export type GetTillApiKeyData = {
    tillId: string;
};

export type GetTillApiKeyResponse = (ApiKey);

export type RevokeTillApiKeyData = {
    tillId: string;
};

export type RevokeTillApiKeyResponse = (ApiKey);

export type RenewTillApiKeyData = {
    tillId: string;
};

export type RenewTillApiKeyResponse = (ApiKey);

export type GetTillByIdData = {
    tillId: string;
};

export type GetTillByIdResponse = (TillDetails);

export type UpdateTillData = {
    requestBody: UpdateTillRequest;
    tillId: string;
};

export type UpdateTillResponse = (Till);

export type FindAllFeatureFlagsResponse = (Array<FeatureFlag>);